import { render, staticRenderFns } from "./addTeachRearch.vue?vue&type=template&id=25b0d361&scoped=true"
import script from "./addTeachRearch.vue?vue&type=script&lang=js"
export * from "./addTeachRearch.vue?vue&type=script&lang=js"
import style0 from "./addTeachRearch.vue?vue&type=style&index=0&id=25b0d361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b0d361",
  null
  
)

export default component.exports